"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
var Scroll = /** @class */ (function () {
    function Scroll(value) {
        this.scrollPositionThreshold = value;
        this.hasRendered = false;
        this.throttlePause = false;
    }
    Scroll.prototype.init = function (actionCallback) {
        var _this = this;
        (0, helpers_1.bindEvent)(window, 'scroll', function () {
            if (_this.hasRendered || _this.throttlePause)
                return;
            _this.throttlePause = true;
            setTimeout(function () {
                _this.throttlePause = false;
                var scrollPosition = (0, helpers_1.getScrollPosition)();
                if (scrollPosition >= _this.scrollPositionThreshold) {
                    _this.hasRendered = true;
                    actionCallback();
                }
            }, 150);
        });
    };
    Scroll.prototype.toString = function () {
        return "trigger scroll when user has scroller ".concat(this.scrollPositionThreshold, "% of the page");
    };
    return Scroll;
}());
exports.default = Scroll;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2Nyb2xsLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvc2VydmljZXMvdHJpZ2dlcnMvU2Nyb2xsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEscUNBQXdEO0FBR3hEO0lBS0ksZ0JBQVksS0FBYTtRQUNyQixJQUFJLENBQUMsdUJBQXVCLEdBQUcsS0FBSyxDQUFBO1FBQ3BDLElBQUksQ0FBQyxXQUFXLEdBQUcsS0FBSyxDQUFBO1FBQ3hCLElBQUksQ0FBQyxhQUFhLEdBQUcsS0FBSyxDQUFBO0lBQzlCLENBQUM7SUFFRCxxQkFBSSxHQUFKLFVBQUssY0FBNkI7UUFBbEMsaUJBaUJDO1FBaEJHLElBQUEsbUJBQVMsRUFBQyxNQUFNLEVBQUUsUUFBUSxFQUFFO1lBQ3hCLElBQUksS0FBSSxDQUFDLFdBQVcsSUFBSSxLQUFJLENBQUMsYUFBYTtnQkFBRSxPQUFNO1lBRWxELEtBQUksQ0FBQyxhQUFhLEdBQUcsSUFBSSxDQUFBO1lBRXpCLFVBQVUsQ0FBQztnQkFDUCxLQUFJLENBQUMsYUFBYSxHQUFHLEtBQUssQ0FBQTtnQkFFMUIsSUFBTSxjQUFjLEdBQUcsSUFBQSwyQkFBaUIsR0FBRSxDQUFBO2dCQUUxQyxJQUFJLGNBQWMsSUFBSSxLQUFJLENBQUMsdUJBQXVCLEVBQUU7b0JBQ2hELEtBQUksQ0FBQyxXQUFXLEdBQUcsSUFBSSxDQUFBO29CQUN2QixjQUFjLEVBQUUsQ0FBQTtpQkFDbkI7WUFDTCxDQUFDLEVBQUUsR0FBRyxDQUFDLENBQUE7UUFDWCxDQUFDLENBQUMsQ0FBQTtJQUNOLENBQUM7SUFFRCx5QkFBUSxHQUFSO1FBQ0ksT0FBTyxnREFBeUMsSUFBSSxDQUFDLHVCQUF1QixrQkFBZSxDQUFBO0lBQy9GLENBQUM7SUFDTCxhQUFDO0FBQUQsQ0FBQyxBQWpDRCxJQWlDQyJ9